import {HttpClient} from '@angular/common/http';
import {Injectable} from '@angular/core';
import {AntragRequest, BackendOberflaecheService} from '@vhv/tarifrechner-common';
import {ActivatedRoute} from '@angular/router';
import {RateBaugeraeteService} from '../rate/rate-baugeraete.service';
import type {BaugeraeteFachdaten} from "../model/baugeraete-fachdaten";
import type {BaugeraeteTarifrechnerDaten} from "../model/baugeraete-tarifrechner-daten";

@Injectable({
    providedIn: 'root',
})
export class SendeAntragsdatenBaugeraeteService {
    constructor(
        private http: HttpClient,
        private backendOberflaecheService: BackendOberflaecheService,
        private inputRoute: ActivatedRoute,
        private rateBaugeraeteService: RateBaugeraeteService
    ) {}

    public getAntragRequest(): AntragRequest<BaugeraeteFachdaten> {
        const ausgefuellteWerte = this.backendOberflaecheService.getAusgefuellteWerte() as BaugeraeteTarifrechnerDaten;

        return new AntragRequest<BaugeraeteFachdaten>(
            '', // Erstelldatum wird server-seitig bestimmt
            // 2025.05.12, KTR-2074 '', // nicht benötigt für Baugeraete
            ausgefuellteWerte.Firma,
            ausgefuellteWerte.Email,
            ausgefuellteWerte.Telefon,
            ausgefuellteWerte.Anrede,
            ausgefuellteWerte.Titel,
            ausgefuellteWerte.Vorname,
            ausgefuellteWerte.Nachname,
            {
                strasse: ausgefuellteWerte.Strasse,
                hausnummer: ausgefuellteWerte.Hausnummer,
                postleitzahl: ausgefuellteWerte.PLZ,
                ort: ausgefuellteWerte.Ort,
                land: 'Deutschland', // nicht benötigt für Baugeraete
            },
            '', // nicht benötigt für Baugeraete
            '', // nicht benötigt für Baugeraete
            {
                iban: ausgefuellteWerte.IBAN,
                bic: ausgefuellteWerte.BIC,
                kontoinhaberAnrede: ausgefuellteWerte.AbwKontoinhaberAnrede,
                kontoinhaberVorname: ausgefuellteWerte.AbwKontoinhaberVorname,
                kontoinhaberNachname: ausgefuellteWerte.AbwKontoinhaberNachname,
                kontoinhaberAnschrift: {
                    strasse: ausgefuellteWerte.AbwKontoinhaberStrasse,
                    hausnummer: ausgefuellteWerte.AbwKontoinhaberHausnummer,
                    postleitzahl: ausgefuellteWerte.AbwKontoinhaberPLZ,
                    ort: ausgefuellteWerte.AbwKontoinhaberOrt,
                    land: 'Deutschland', // nicht benötigt für Baugeraete
                },
            },
            ausgefuellteWerte.Versicherungsbeginn,
            'JAEHRLICH', // immer jährlich für Baugeraete, wird auch vom Backend überschrieben
            ausgefuellteWerte.Vermittlernummer,
            this.rateBaugeraeteService.getFachdaten()
        );
    }

    public getDownloadRequest(): { data: AntragRequest<BaugeraeteFachdaten> } {
        const baugeraeteAntragRequest = this.getAntragRequest();
        const baugeraeteAntragJsonObject = JSON.parse(JSON.stringify(baugeraeteAntragRequest));

        // Setze Platzhalterwerte ins Pflichtfeld zur Dokumentengenerierung
        baugeraeteAntragJsonObject.fachdaten.downloadZeitstempel = 'n/a';

        return {
            data: baugeraeteAntragJsonObject
        };
    }

}
